import React from 'react';
import DsModal from '../DsModal';
import '../../../css/common/events/EventMembersVisibilityConfirmModal.css';

export default function EventMembersVisibilityConfirmModal({
  open = false,
  saving = false,
  unpublishedEventLabels = [],
  currentEventLabel = '',
  onClose,
  onConfirmGroupAll,
  onConfirmSingle,
}) {
  return (
    <DsModal
      open={open}
      onClose={onClose}
      title="参加アーティスト公開の確認"
      size="sm"
      dismissible={!saving}
    >
      <p className="event-members-visibility-confirm-modal__desc">公開方法を選択してください。</p>
      <div className="event-members-visibility-confirm-modal__choices">
        <button
          type="button"
          className="event-members-visibility-confirm-modal__choice is-primary"
          onClick={onConfirmGroupAll}
          disabled={saving}
        >
          <span className="event-members-visibility-confirm-modal__choice-title">グループイベントすべて公開</span>
          <span className="event-members-visibility-confirm-modal__choice-note">
            未公開の公演を一括で公開します。
          </span>
        </button>
        <button
          type="button"
          className="event-members-visibility-confirm-modal__choice"
          onClick={onConfirmSingle}
          disabled={saving}
        >
          <span className="event-members-visibility-confirm-modal__choice-title">この公演のみ公開</span>
          <span className="event-members-visibility-confirm-modal__choice-note">
            {currentEventLabel || 'この公演'}のみ公開します。
          </span>
        </button>
      </div>
      {unpublishedEventLabels.length > 0 ? (
        <p className="event-members-visibility-confirm-modal__target">
          公開対象（未公開）: {unpublishedEventLabels.join(' / ')}
        </p>
      ) : null}
    </DsModal>
  );
}
